import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';

import $, { data } from 'jquery';

import Master from '../Master';
import AlertMessage from '../Alert';
import AlertActions from '../../actions/alert';
import DatePicker from '../DatePicker';
import Button from '../Buttons';
import Select from '../Select';
import Collapsible from '../Panels/Collapsible';

import MonthlyReportTable from './MonthlyReportTable';
import { FormatDate, DestroyTable } from '../../utils/Functions';
import IziToast from '../IziToast';
import { filter } from 'lodash';
 
const MonthlyReport = ({ user, dispatch, alert }) => {

//   refs
const propertyRef = useRef(null);
const invoiceNoRef = useRef(null);
const unitRef = useRef(null);
const descriptionRef = useRef(null);
const tenantRef = useRef(null);
const ownerRef = useRef(null);
const statementTypeRef = useRef(null);

// state
const today = new Date();
const [total, setTotal] = useState(0);
const firstDay = new Date(today.getFullYear(), today.getMonth() -1, 1);
const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
const [lowerDate, setLowerDate] = useState(firstDay);
const [upperDate, setUpperDate] = useState(lastDay);
const [properties, setProperties] = useState([]);
const [propertyId, setPropertyId] = useState('');
const [units, setUnits] = useState([]);
const [tenantsList, setTenantsList] = useState([]);
const [tenants, setTenants] = useState([]);
const [alltenants, setAlltenants] = useState([]);
const [tenantId, setTenantId] = useState('');
const [unitNo, setUnitNo] = useState();
const [arrears, setArrears] = useState([]);
const [arrears_all, setArrearsAll] = useState([]);
const [unitNumbers, setUnitNumbers] = useState([]);
const [statement_type, setStatementType] = useState(0);
// Unit owners are loaded once and filtered by property so we can scope the
// Unit Owner statement to a specific owner. Statement type 2 = unit owner.
const [unitOwnersList, setUnitOwnersList] = useState([]);
const [unitOwners, setUnitOwners] = useState([]);
const [unitOwnerId, setUnitOwnerId] = useState('');

const [invoiceNumbers, setInvoiceNumbers] = useState([]);
const [invoiceNo, setInvoiceNo] = useState('');

const [descriptions, setDescriptions] = useState([])
const [description, setDescription] = useState('')

// Statement-entry Type filter (Rent / Water Bill / Service Charge / Extra
// Charge / Commission). Applied client-side inside MonthlyReportTable so it
// stays orthogonal to the existing description/invoice/unit filters.
const [typeFilter, setTypeFilter] = useState('')

// Table states
const [isLoading, setIsLoading] = useState(false);
const [error, setError] = useState(null);


const userToken = user ? user.token : {};
const statement_types = [
  {name: "Tenant Statement", value: 0},
  {name: "Landlord Statement", value: 1},
  {name: "Unit Owner Statement", value: 2},
]

const requestConfig = {
headers: {
    Authorization: `Bearer ${userToken}`,
    'Content-Type': 'application/json',
},
};


useEffect(() => {
  dispatch(AlertActions.clear());
}, [dispatch]);

useEffect(()=> {
  filterLocally({
    invoiceNo: null,
    unitNo: unitNo,
    descText: null
  });
}, [unitNo]);

useEffect(() => {
    (async () => {
      try {
        let url = `/byuser?status=active&user_id=${user.id}`;
        if (user && user.type === 'admin') {
          url = '?take=1000&where={"status":"active"}&order={"name":"ASC"}';
        }
        const {
          data: { response },
        } = await axios.get(
          `${process.env.REACT_APP_API_URL}properties${url}`,
          requestConfig,
        );

        setProperties(response);
        loadUnits(response);

        $(propertyRef.current)
          .select2()
          .on('change', (event) => {
            setPropertyId(event.val);
        });
          
      } catch (_) {
        //
      }
    })();
  }, []);

useEffect(() => {
  filterUniqueUnits(propertyId)
},[propertyId]);


useEffect(()=> {
  invoiceFilter(invoiceNo)
}, [invoiceNo])

useEffect(()=> {
  descriptionFilter(description)
}, [description])

useEffect(() => {
  // "Total Balance Due" reflects the CURRENTLY-FILTERED view — including
  // the Type filter (applied in the table) — not the whole statement.
  // We sum each visible row's net effect on what's owed instead of taking
  // the last row's running balance (which is a full-stream figure and
  // ignores the Type filter):
  //   - a charge (credit) increases the amount owed   -> contributes -credit
  //   - a payment (debit) reduces it                  -> contributes +debit
  //   - the "Balance brought forward" opening row carries its own balance
  // Sign convention matches the ledger: negative = owed. Being a sum, it's
  // also order-independent, so it's correct even if the table is re-sorted.
  const visible = typeFilter
    ? (arrears || []).filter((r) => r.type === typeFilter)
    : (arrears || []);
  if (visible.length === 0) {
    setTotal(0);
    return;
  }
  const sum = visible.reduce((acc, r) => {
    if (r.isOpening) return acc + (Number(r.balance) || 0);
    return acc + (Number(r.debit) || 0) - (Number(r.credit) || 0);
  }, 0);
  setTotal(sum);
}, [arrears, typeFilter]);

// Clear the inactive recipient when the statement type switches so we
// don't carry a stale id into the next search. Also nudge select2 to
// drop the visible selection from the now-hidden dropdown.
useEffect(() => {
  if (Number(statement_type) === 2) {
    setTenantId('');
    if (tenantRef.current) $(tenantRef.current).val('').trigger('change.select2');
  } else {
    setUnitOwnerId('');
    if (ownerRef.current) $(ownerRef.current).val('').trigger('change.select2');
  }
}, [statement_type]);

useEffect(()=> {
  $(statementTypeRef.current)
    .select2()
    .on('change', (event) => {
      // Use the native value first (more reliable across select2 versions).
      const raw = (event && event.target && event.target.value) || (event && event.val) || '0';
      const n = Number(raw);
      // Accept 0/1/2; default to 0 (Tenant Statement) on anything else.
      setStatementType(Number.isFinite(n) && (n === 0 || n === 1 || n === 2) ? n : 0);
  });
}, [statement_types])

async function filterUniqueUnits(property_id){

  (async () =>{
    try{
    const filtered =  alltenants.filter((item)=>{
      return item.unit.property_id == property_id && item.other_details;
    })

    setTenants(filtered);

    const unique =  [...new Set(filtered.map(item => item.other_details.unit_number))];
    setUnitNumbers(unique);

    // Also scope owners to the picked property so the Unit Owner dropdown
    // only shows relevant owners.
    if (property_id) {
      setUnitOwners(unitOwnersList.filter((o) => o && o.property_id === property_id));
    } else {
      setUnitOwners(unitOwnersList);
    }
    setUnitOwnerId('');

    $(unitRef.current)
      .select2()
      .on('change', (event) => {
        setUnitNo(event.val);
  });

  }catch(_){
  }
  })()

}

async function descriptionFilter(description_text){
  setDescription(description_text)
  filterLocally({invoiceNo:null, unitNo:null, descText:description_text})
}

async function onSearchInvoice(){
  setInvoiceNo('');
  setDescription('');
  setUnitNo('');
  setIsLoading(true);

  await loadArrears();
  await filterLocally({invoiceNo:null, unitNo:null, descText:null});
  setIsLoading(false);

}


async function invoiceFilter(invoiceNo){
  (async () => {
    try{
      filterLocally({invoiceNo:invoiceNo, unitNo:null, descText:null});
     
    }catch(_){

    }
  })()
}


async function filterLocally(
  object=null
  ){
  
  const invoiceNumber = object.invoiceNo;
  let unitNumber = object.unitNo;
  const descText = object.descText;

  DestroyTable('arrears_table')

  if(!unitNumber){
    unitNumber = unitNo;
  }

  if(unitNumber){

    if(invoiceNo || descText) {
   
    const filtered = arrears.filter((item)=>{
      return item.houseUnit === unitNumber
    })
    setArrears(filtered)

  } else {

    const filtered = arrears_all.filter((item)=>{
      return item.houseUnit === unitNumber
    })
    setArrears(filtered)

  }
  }


  if(invoiceNumber){
    if(unitNumber || descText){

      const filtered = arrears.filter((item)=>{
        return item.invoiceNo == invoiceNumber
      })
      setArrears(filtered);

    }
    else {
    
      const filtered = arrears_all.filter((item)=>{
        return item.invoiceNo == invoiceNumber
      })
      setArrears(filtered)
    }
  }


  if(descText){

    if(unitNumber || invoiceNo){

    console.log("Filtering by desc")
    const filtered = arrears.filter((item)=>{
      return item.description == descText
    })
    setArrears(filtered);

  } else {

    const filtered = arrears.filter((item)=>{
      return item.description == descText
    })
    setArrears(filtered);

  }
  }


}

/**
 * 
 *
 */
async function loadArrears(){
if(propertyId){
  // Resolve the payer filter. Tenant statements use tenantId directly; unit
  // owner statements pick the selected owner's user_id (since invoice
  // payer_id is the user.id for unit-owner-paid invoices).
  let payerId = '';
  // statement_type comes back from select2 as a string ("0"/"1"/"2") so
  // compare loosely or coerce — using Number() avoids subtle == bugs.
  const stmtType = Number(statement_type);
  if (stmtType === 2) {
    const owner = unitOwners.find((o) => o.id === unitOwnerId);
    if (owner && owner.user_id) payerId = owner.user_id;
  } else if (tenantId) {
    payerId = tenantId;
  }
  let url = '';
  if (payerId) {
    url = `invoices/statement?where={"invoice_date":"btwn::${FormatDate(lowerDate)},${FormatDate(upperDate)}", "payee_id":"${propertyId}", "payer_id":"${payerId}"}`;
  } else {
    url = `invoices/statement?where={"invoice_date":"btwn::${FormatDate(lowerDate)},${FormatDate(upperDate)}", "payee_id":"${propertyId}"}`;
  }
  const headers = {
    Authorization: `Bearer ${userToken}`,
    'Content-Type': 'application/json',
  };
  if (stmtType === 1) headers.withcommission = true;
  if (stmtType === 2) headers.unitowner = 'true';
  const localRequestConfig = { headers };
  const {
    data: { response },
  } = await axios.get(
    `${process.env.REACT_APP_API_URL}${url}`,
    localRequestConfig,
  );

  setArrears(response);
  setArrearsAll(response);
  getDescAndInvoiceNumbers(response);

  }else{
    dispatch(AlertActions.info('Select property to continue'));
  }

}


async function getDescAndInvoiceNumbers(arrears){
  (async () => {
    try{
      const filtered =  arrears.filter((item)=>{
        return item.invoiceNo !=null;
      })

      const unique =  [...new Set(filtered.map(item => item.invoiceNo))]
      setInvoiceNumbers(unique);

      const filtered2 =  arrears.filter((item)=>{
        return item.description !=null;
      })

      const unique2 =  [...new Set(filtered2.map(item => item.description))]
      setDescriptions(unique2);
       
      $(invoiceNoRef.current)
        .select2()
        .on('change', (event) => {
          setInvoiceNo(event.val);
      });

      $(descriptionRef.current)
        .select2()
        .on('change', (event)=> {
          setDescription(event.val);
        })
  }catch(_){}
})()

}
 /**
   *
   * @param {[]} property
   */
  async function loadUnits(property) {
    const propertyIds = property.map((item) => {
      return item.id;
    });
    let urlUnits;
    // get units
    if (user.type === 'admin') {
      urlUnits = `${process.env.REACT_APP_API_URL}units?take=10000`;
    } else {
      urlUnits = `${
        process.env.REACT_APP_API_URL
      }units?take=10000&where={"property_id":"in::${propertyIds.join()}"}`;
    }
    try {
      const {
        data: { response: unitsInfo },
      } = await axios.get(urlUnits, requestConfig);
      setUnits(unitsInfo);
      loadTenants(unitsInfo);
      loadUnitOwners(property);

      $(tenantRef.current)
        .select2()
        .on('change', (event) => {
          const val = (event && event.target && event.target.value) || (event && event.val) || '';
          setTenantId(val);
      });

      // Owner dropdown is always mounted (just hidden) so the ref is
      // available here regardless of which statement type is active.
      if (ownerRef.current) {
        $(ownerRef.current)
          .select2()
          .on('change', (event) => {
            const val = (event && event.target && event.target.value) || (event && event.val) || '';
            setUnitOwnerId(val);
          });
      }

    } catch (_) {
      //
    }
  }

  /**
   * Load unit owners for the user's accessible properties so the Unit Owner
   * statement can scope by an individual owner.
   * @param {[]} property
   */
  async function loadUnitOwners(property) {
    const propertyIds = (property || []).map((item) => item.id);
    let urlOwners;
    if (user.type === 'admin') {
      urlOwners = `${process.env.REACT_APP_API_URL}unitowners?take=10000`;
    } else {
      urlOwners = `${process.env.REACT_APP_API_URL}unitowners?take=10000&where={"property_id":"in::${propertyIds.join()}"}`;
    }
    try {
      const { data: { response } } = await axios.get(urlOwners, requestConfig);
      const owners = response || [];
      setUnitOwners(owners);
      setUnitOwnersList(owners);
    } catch (_) {
      // Non-fatal — Unit Owner statement just won't have any options.
    }
  }

    /**
   *
   * @param {[]} unitsInfo
   */
  function loadTenants(unitsInfo) {
    function findUnit(id) {
      return unitsInfo.find((item) => {
        return item.id === id;
      });
    }
    (async () => {
      try {
        const unitIds = unitsInfo.map((item) => {
          return item.id;
        });
        let urlTenants;
        // get tenats
        if (user.type === 'admin') {
          urlTenants = `${process.env.REACT_APP_API_URL}tenants?take=10000`;
        } else {
          urlTenants = `${
            process.env.REACT_APP_API_URL
          }tenants?take=10000&where={"unit_id":"in::${unitIds.join()}"}`;
        }
        const {
          data: { response },
        } = await axios.get(urlTenants, requestConfig);
        const mapped = response.map((item) => {
          const element = item;
          element.unit = findUnit(element.unit_id);
          return element;
        });
        setTenants(mapped);
        setAlltenants(mapped);
        setTenantsList(mapped);
        
      } catch (_) {
        //
      }
    })();
 }

return (
    <Master redirectLink="monthlyreport" title="Report" source="Account Statement">
        <div className="row">
            <div className="col-md-12">
            {alert && alert.message && (
                <AlertMessage
                alertType={`alert ${alert.type}`}
                message={alert.message}
                />
            )}
            </div>
        </div>
        <div className="row">
        <div className="col-md-9">
          <div className="row">
            <Select
              caption="Property Name"
              value={propertyId}
              onChange={(event) => {
                setPropertyId(event.target.value);
              }}
              columnWidth={4}
              inputRef={propertyRef}
            >
              <option value="">Select property name</option>
              {properties.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </Select>
            {/* Statement Type moved up so the field order follows the
                natural picking flow: Property → Statement Type →
                Recipient (Tenant or Unit Owner). */}
            <Select
              caption="Statement Type"
              value={String(statement_type)}
              onChange={(event) => {
                const n = Number(event.target.value);
                setStatementType(Number.isFinite(n) ? n : 0);
              }}
              columnWidth={4}
              inputRef={statementTypeRef}
            >
              {statement_types.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.name}
                </option>
              ))}
            </Select>
            {/* Tenant vs Unit Owner selector — both are mounted; only one
                is shown based on Statement Type. Keeps the select2 binding
                stable across toggles. Unit Owner pick maps to user_id at
                load time so it matches the invoice payer_id. */}
            <Select
              caption="Tenant"
              value={tenantId}
              onChange={(event) => {
                setTenantId(event.target.value);
              }}
              columnWidth={4}
              inputRef={tenantRef}
              wrapperStyle={{ display: Number(statement_type) === 2 ? 'none' : 'block' }}
            >
              <option value="">Select tenant</option>
              {tenants.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {`${item.first_name} ${item.last_name} | ${item.other_details ? item.other_details.unit_number : '--' }`}
                  </option>
                );
              })}
            </Select>
            <Select
              caption="Unit Owner"
              value={unitOwnerId}
              onChange={(event) => {
                setUnitOwnerId(event.target.value);
              }}
              columnWidth={4}
              inputRef={ownerRef}
              wrapperStyle={{ display: Number(statement_type) === 2 ? 'block' : 'none' }}
            >
              <option value="">Select unit owner</option>
              {unitOwners.map((item) => {
                const u = item.user || {};
                const name = `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email || 'Owner';
                const units = Array.isArray(item.unit_numbers) && item.unit_numbers.length > 0
                  ? item.unit_numbers
                    .map((x) => (typeof x === 'string' ? x : (x && x.number) || ''))
                    .filter(Boolean)
                    .join(', ')
                  : '--';
                return (
                  <option key={item.id} value={item.id}>
                    {`${name} | ${units}`}
                  </option>
                );
              })}
            </Select>
            {/* <Select
              caption="Unit No."
              value={unitNo}
              onChange={(event) => {
                setUnitNo(event.target.value);
              }}
              columnWidth={4}
              inputRef={unitRef}
            >
              <option value="">Select Unit Number</option>
              {unitNumbers.map((item) => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </Select> */}
            <Select
                caption="Invoice Number"
                value={invoiceNo}
                columnWidth={4}
                onChange={(event)=>{
                  setInvoiceNo(event.target.value);
                }}
                inputRef={invoiceNoRef}
                >
                    <option value="">Unit Number</option>
                    {invoiceNumbers.map((item) => {
                    return (
                      <option key={item} value={item}>
                        {item}
                      </option>
                  );
              })}
            </Select>

            <Select
                caption="Description"
                value={description}
                columnWidth={4}
                onChange={(event)=>{
                  setDescription(event.target.value)
                }}
                inputRef={descriptionRef}
                >
                    <option value="">Description</option>
                    {descriptions.map((item) => {
                    return (
                      <option key={item} value={item}>
                        {item}
                      </option>
                  );})}
            </Select>

            <Select
              caption="Type"
              value={typeFilter}
              onChange={(event) => setTypeFilter(event.target.value)}
              columnWidth={4}
            >
              <option value="">All types</option>
              <option value="Rent">Rent</option>
              <option value="Water Bill">Water Bill</option>
              <option value="Service Charge">Service Charge</option>
              <option value="Extra Charge">Extra Charge</option>
              <option value="Commission">Commission</option>
            </Select>

          </div>
          <div className="row">
            <DatePicker
              placeholder="Select date from"
              caption="Date From"
              onChange={(date) => {
                return setLowerDate(date);
              }}
              columnWidth={2}
              selected={lowerDate}
            />
            <DatePicker
              placeholder="Select date to"
              caption="Date To  &nbsp; &nbsp;"
              onChange={(date) => {
                return setUpperDate(date);
              }}
              columnWidth={2}
              selected={upperDate}
            />
            <div className="col-md-3 invoice-button">
              <Button
                caption="Search"
                cssClass="btn-success"
                onClick={onSearchInvoice}
                type="button"
                isBlack={false}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="hpanel">
            <div className="panel-body">
              <span>Total Balance Due:</span>
              <br />
              <h1 className="primary-red">{ total < 0 ? `Ksh (${(-total).toLocaleString(undefined, { maximumFractionDigits: 2 })})` : `Ksh ${total.toLocaleString(undefined, { maximumFractionDigits: 2 })}`}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <Collapsible columnWidth={12} caption="Monthly Report Table" controlId="invoices">
          <MonthlyReportTable
            isLoading={isLoading}
            error={error}
            arrears={arrears}
            typeFilter={typeFilter}
          />
        </Collapsible>
      </div>
      
    </Master>
)


}
const mapStateToProps = (state) => {
    return state;
  };
  
  MonthlyReport.propTypes = {
    user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    dispatch: PropTypes.func.isRequired,
    alert: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  };
  
  MonthlyReport.defaultProps = {
    user: {},
    alert: {},
  };
  
  export default connect(mapStateToProps)(MonthlyReport);
  